import { handleError } from "@/utils/parseApiReturn";
import { ApiService } from "../../../config";
import {
  TAccountResponse,
  EditAccountResponse,
  RegenerateTokenResponse,
  TAccountRes,
  TDeleteAccountResponse,
  TAccountTokensResponse,
  TDeleteAccountTokenResponse
} from "../models";
const defaultRoute = "/accounts";

const setCurrentScenario = async (
  accountId: string,
  scenarioId: string
): Promise<string | null> => {
  try {
    const { data } = await ApiService.post(
      defaultRoute + "/set-current-scenario",
      {
        accountId,
        scenarioId
      }
    );
    return data.message;
  } catch (error) {
    handleError(error, "Erro inesperado:");
    return null;
  }
};
const getAccounts = async (
  page: number,
  searchParam: string,
  limit: number
): Promise<TAccountRes> => {
  try {
    const res = await ApiService.get(defaultRoute, {
      page,
      searchParam,
      limit
    });
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro inesperado ao obter contas:");
  }
};

const regenerateToken = async (
  accountId: string,
  name: string
): Promise<RegenerateTokenResponse> => {
  try {
    const res = await ApiService.post(defaultRoute + "/regenerate-token", {
      accountId,
      name
    });
    return res.data as RegenerateTokenResponse;
  } catch (error: unknown) {
    const { message, success } = handleError(
      error,
      "Erro na requisição para regenerar o token"
    );
    return {
      success,
      value: "",
      message
    };
  }
};
const editAccount = async (
  id: string,
  name: string
): Promise<EditAccountResponse> => {
  try {
    const res = await ApiService.patch(`${defaultRoute}/${id}`, { name });
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para atualizar conta:");
  }
};

const createAccount = async (
  name: string,
  cnpj: string
): Promise<TAccountResponse> => {
  try {
    const res = await ApiService.post(defaultRoute + "/create", { name, cnpj });
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para criar conta:");
  }
};

const deleteAccount = async (id: number): Promise<TDeleteAccountResponse> => {
  try {
    const res = await ApiService.delete(`${defaultRoute}/${id}`);
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para excluir conta:");
  }
};
const getAccountsTokens = async (
  page: number,
  limit: number,
  accountId: number,
  orderBy: string
): Promise<TAccountTokensResponse> => {
  try {
    const response = await ApiService.get(
      `${defaultRoute}/${accountId}/tokens`,
      {
        page,
        limit,
        orderBy
      }
    );
    return response.data;
  } catch (error) {
    return handleError(error, "Erro na requisição para obter tokens da conta");
  }
};
const deleteAccountToken = async (
  accountId: number,
  tokenId: number
): Promise<TDeleteAccountTokenResponse> => {
  try {
    const res = await ApiService.delete(
      `${defaultRoute}/${accountId}/tokens/${tokenId}`
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(
      error,
      "Erro na requisição para excluir tokens da conta"
    );
  }
};

const verifyAddress = async (
  accountId: number
) => {
  try {
    const { data } = await ApiService.get(`accounts/${accountId}/address`);

    return { success: true, addressFilled: data.addressFilled };
  } catch (error: any) {
    console.error("error", error);
    const { message } = error.response.data;
    return { success: false, message };
  }
};

const updateAddress = async (
  accountId: number,
  zipCode: string,
  street: string,
  streetNumber: string,
  complement: string,
  neighborhood: string,
  city: string,
  state: string
) => {
  try {
    const { data } = await ApiService.patch(`accounts/${accountId}/address`, {
      zipCode,
      street,
      streetNumber,
      complement,
      neighborhood,
      city,
      state
    });
    return { success: true, message: data.message };
  } catch (error: any) {
    console.error("error", error);
    const { message } = error.response.data;
    return { success: false, message };
  }
};

export const AccountsService = {
  setCurrentScenario,
  getAccounts,
  regenerateToken,
  editAccount,
  createAccount,
  deleteAccount,
  getAccountsTokens,
  deleteAccountToken,
  verifyAddress,
  updateAddress,
};
